import { withStyles } from "@mui/styles";
import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import styles from "./index.styles";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import Divider from "@mui/material/Divider";
import { IconButton, ListItemText } from "@mui/material";
import spinner from "../../assign-prescriptions/images/spinner.gif";
import EnhancedTableToolbar from "./EnhancedTableToolBar.index";
import EnhancedTableHead from "./EnhancedTableHead.index";
import Menu from "@mui/material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Avatar from "@mui/material/Avatar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import moment from "moment-timezone";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const localeTheme = createTheme(
  {

  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

let TransactionFilterObj = {
  searchtext: "",
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
  group_id: null
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;
class UserInactiveReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      order: "desc",
      orderBy: "created_on",
      selected: [],
      Rows: [],
      page: 0,
      rowsPerPage: 10,
      data: [],
      isDataEmpty: false,
      searchText: "",
      selectedRowId: null,
      openUserDeleteDialog: false,
      userDeletionArr: [],
      disabledUserText: this.props.t("Report.inActive.Disable"),
      openUserDisabledDialog: false,
      userDisabledArr: [],
      totalRecords: 0,
      sortId: "",
      isButtonDisabled: false,
      queryId: "",
      groups: [],
    };
    this.debouceTimeout = null;
  }

  componentDidMount = () => {
    TransactionFilterObj = {
      searchtext: "",
      pageNo: 0,
      pageSize: 10,
      sortOrder: "desc",
      sortColumn: "created_on",
      tableName: "",
    };
    TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
    this.fetchSuggestions();
    this.BindUsersGrid();
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  convertToTimeZone = (requestDate) => {
    let zone;
    zone = sessionStorage.getItem("timeZone");
    const date = moment(new Date(requestDate));
    if (["null", null, "undefined", undefined].includes(zone)) {
      zone = defaultZone;
    }
    return date
      .tz(zone.substring(zone.lastIndexOf(" ") + 1))
      .format("MM/DD/YYYY hh:mm:ss A");
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    this.setState({ selected: newSelected });
  };

  gettingOnSortTableName = (field) => {
    let tablename = "";
    if (
      ["user", "username", "createdon", "lastloginon", "status"].includes(field)
    ) {
      tablename = "users";
    }
    if (["associated account"].includes(field)) {
      tablename = "accounts";
    }
    if (["phone"].includes(field)) {
      tablename = "contacts";
    }
    if (["stock_code", "pucode"].includes(field)) {
      tablename = "prescriptions_master";
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindUsersGrid();
    }
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.data.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    TransactionFilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindUsersGrid();
    }
  };

  handleChangeRowsPerPage = (event) => {
    const { data } = this.state;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindUsersGrid();
    }
  };

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  handleContextClick = (event, n) => {
    event.preventDefault();
    let disabledText;
    if ((n && n.is_enabled) === "true" || (n && n.is_enabled) === true) {
      disabledText = this.props.t("Report.inActive.Disable");
    } else {
      disabledText = this.props.t("Report.inActive.Enable");
    }
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: n.id,
      disabledUserText: disabledText,
    });
  };

  getDifferenceInDays = (sysDate, userDate) => {
    const diffInMs = Math.abs(sysDate - userDate);
    return diffInMs / (1000 * 60 * 60 * 24);
  };

  BindUsersGrid = () => {
    try {
      this.setState({ loader: true });
      fetch(process.env.REACT_APP_BASEURL + "inactiveuserreports", {
        method: "POST",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(TransactionFilterObj),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res && res.results && res.results.length > 0) {
            this.setState({
              data: res.results,
              totalRecords: res && res.total
            });
            setTimeout(() => {
              this.setState({
                isDataEmpty: false,
                loader: res && res.total && false,
                isButtonDisabled: false
              })
            }, 5000)
          } else {
            this.setState({
              isDataEmpty: true,
              data: null,
              loader: false,
              isButtonDisabled: true,
            });
          }
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  handleSearchTextInput = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    event && event.preventDefault();
    this.setState({ searchText: event.target.value });
    TransactionFilterObj.searchtext = event.target.value;
    this.debouceTimeout = setTimeout(() => {
      this.BindUsersGrid();
    }, 1000)
  };

  handleConfirmDelete = () => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDeleteDialog: true,
        userDeletionArr:
          this.state &&
          this.state.data.filter((x) => x.id === this.state.selectedRowId),
      });
    } else {
      this.setState({
        openUserDeleteDialog: true,
        userDeletionArr:
          this.state &&
          this.state.data.filter(
            (x) => this.state && this.state.selected.indexOf(x.id) > -1
          ),
      });
    }
  };

  handleConfirmClose = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDeleteDialog: false,
        selectedRowId: null,
        userDeletionArr: [],
        selected: [],
      });
      this.handleContextClose(event);
    } else
      this.setState({
        openUserDeleteDialog: false,
        selectedRowId: null,
        userDeletionArr: [],
        selected: [],
      });
  };

  handleDeleteConfirmed = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.handleDeleteUser(event);
    } else {
      this.handleDeleteMultipleUsers();
    }
    this.setState({ openUserDeleteDialog: false });
  };

  handleDeleteUser = (event) => {
    this.setState({ loader: true });
    const selecRowID = this.state && this.state.selectedRowId;
    fetch(process.env.REACT_APP_BASEURL + "users/" + selecRowID, {
      method: "DELETE",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    }).then((results) => {
      this.setState({ loader: false });
      const _updatedUsers = this.state.data.filter(
        (x) => x.id !== this.state.selectedRowId
      );
      this.handleContextClose(event);
      this.setState({
        data: JSON.parse(JSON.stringify(_updatedUsers)),
        selected: [],
        selectedRowId: null,
      });
    });
  };

  handleDeleteMultipleUsers = () => {
    this.setState({ loader: true });
    const result = fetch(
      process.env.REACT_APP_BASEURL +
      "users/" +
      this.state.selected.join(",").trim(","),
      {
        method: "DELETE",
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      this.setState({ loader: false });
      const newData = [];
      this.state.data.forEach((item) => {
        if (this.state.selected.indexOf(item.id) === -1) {
          newData.push(item);
        }
      });

      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
      });
    });
  };

  handleConfirmDisabled = () => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDisabledDialog: true,
        userDisabledArr:
          this.state &&
          this.state.data.filter((x) => x.id === this.state.selectedRowId),
      });
    } else {
      this.setState({
        openUserDisabledDialog: true,
        userDisabledArr:
          this.state &&
          this.state.data.filter((x) => this.state.selected.indexOf(x.id) > -1),
      });
    }
  };

  handleDisabledConfirmClose = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.setState({
        openUserDisabledDialog: false,
        selectedRowId: null,
        userDisabledArr: [],
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        openUserDisabledDialog: false,
        selectedRowId: null,
        userDisabledArr: [],
      });
    }
  };

  hanldeConfirmDisabledUsers = (event) => {
    if (this.state && this.state.selectedRowId) {
      this.handleDisabledUser(event);
      this.setState({ openUserDisabledDialog: false });
      toast.success(
        `${this.props.t('Toast.User')} ${this.state && this.state.disabledUserText} ${this.props.t('Toast.Success')}`
      );
    }
  };

  handleDisabledUser = (event) => {
    this.setState({ loader: true });
    const rowIdToDisable = this.state.selectedRowId;
    const DisUser = {
      id: rowIdToDisable,
      is_enabled:
        this.state.disabledUserText.toLowerCase() ===
          String(this.props.t("Report.inActive.Disable")).toLowerCase()
          ? false
          : true,
    };
    const result = fetch(process.env.REACT_APP_BASEURL + "userdis/", {
      method: "post",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(DisUser),
    }).then((response) => {
      try {
        return response.text();
      } catch (error) {
        return null;
      }
    });
    result.then((result) => {
      this.setState({ loader: false });
      this.handleContextClose(event);
      this.BindUsersGrid();
    });
  };

  exportCSVReort = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + "CSV/InActiveUserReport", {
      method: "POST",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(TransactionFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRows = [];
        let columns = [
          [
            "ID",
            "Name",
            "UserName",
            "Associated Account",
            "Phone",
            "Created On",
            "LastLogin On",
            "Status",
          ],
        ];
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        if (result !== undefined && result !== "undefined") {
          if (result && result.length > 0) {
            for (let i of result) {
              columns.push([
                i.name,
                i.username,
                i.accountname,
                i.phone,
                i.created_on ? this.convertToTimeZone(i && i.created_on) : "",
                i.last_login_on
                  ? this.convertToTimeZone(i && i.last_login_on)
                  : "",
                i.is_enabled === "true" || i.is_enabled === true
                  ? "Enabled"
                  : "Disabled",
              ]);
            }
          }

          for (let i of columns) {
            csvRows.push(i.join(","));
          }
          let csvString = csvRows.join("%0A");
          let element = document.createElement("a");
          element.href = "data:attachment/csv." + csvString;
          element.target = "_Blank";
          element.download = "InActiveUsersReport.csv";
          document.body.appendChild(element);
          element.click();
        }
      });
  };

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindUsersGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const { classes, t } = this.props;
    const {
      data,
      totalRecords,
      selected,
      anchorEl,
      isDataEmpty,
      searchText,
      loader,
      openUserDeleteDialog,
      userDeletionArr,
      isButtonDisabled,
      queryId, groups
    } = this.state;
    const contextOpen = Boolean(anchorEl);
    return (
      <React.Fragment>
        {loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <Paper className={classes.root}>
          {/* Start Delete Dialog..*/}
          <Dialog
            open={openUserDeleteDialog || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {t("Report.inActive.AreYouSureText")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {t("Report.inActive.AreYouSureBodyText")}
                <ul>
                  {userDeletionArr &&
                    userDeletionArr.length > 0 &&
                    userDeletionArr.map((ele, index) => {
                      return <li key={index}>{ele && ele.name}</li>;
                    })}
                </ul>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleConfirmClose}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Report.inActive.CancelButton")}
              </Button>
              <Button
                onClick={this.handleDeleteConfirmed}
                color="primary"
                autoFocus
                className={classes.primaryButton}
              >
                {t("Report.inActive.DeleteButton")}
              </Button>
            </DialogActions>
          </Dialog>
          {/* End Delete Dialog..*/}
          {/* Start User Disable Dialog */}
          <Dialog
            open={this.state.openUserDisabledDialog || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {t("Report.inActive.AreYouSureWantTo")}{" "}
              {`${this.state && this.state.disabledUserText}?`}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {t("Report.inActive.AreYouSureWantTo")}{" "}
                {this.state && this.state.disabledUserText} user(s):
                <ul>
                  {this.state.userDisabledArr &&
                    this.state.userDisabledArr.map(function (x) {
                      return <li>{x.name}</li>;
                    })}
                </ul>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleDisabledConfirmClose}
                color="primary"
                className={classes.primaryButton}
              >
                {t("Report.inActive.CancelButton")}
              </Button>
              <Button
                onClick={this.hanldeConfirmDisabledUsers}
                color="primary"
                autoFocus
                className={classes.primaryButton}
              >
                {t("Report.inActive.YesButton")}
              </Button>
            </DialogActions>
          </Dialog>
          {/* End User Disabled Dialog.. */}
          <EnhancedTableToolbar
            NumRowsSelected={selected.length}
            SearchText={searchText}
            OnHanleSerachTextInput={this.handleSearchTextInput}
            OnConfirmDeleteUser={this.handleConfirmDelete}
            OnGenerateCSVReport={this.exportCSVReort}
            IsButtonDisabled={isButtonDisabled}
            queryId={queryId}
            groups={groups}
            handleInputChange={this.handleInputChange}
            handleSuggestionClick={this.handleSuggestionClick}
          />
          <div className={classes.tableWrapper}>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              open={contextOpen}
              onClose={this.handleContextClose}
              PaperProps={{
                style: {
                  maxHeight: 48 * 4.5,
                  width: 200,
                },
              }}
            >
              <MenuItem
                key="Disable"
                onClick={this.handleConfirmDisabled}
                sx={{ height: "40px" }}
              >
                <ListItemText>
                  {this.state && this.state.disabledUserText}
                </ListItemText>
              </MenuItem>
              <MenuItem
                key="delete"
                onClick={this.handleConfirmDelete}
                sx={{ height: "40px" }}
              >
                <ListItemText>{t("Report.inActive.Delete")}</ListItemText>
              </MenuItem>
            </Menu>
            <Divider
              style={{
                marginTop: "10px",
                height: "5px",
                borderColor: "rgba(0, 0, 0, 0.12)",
                borderStyle: "solid",
                borderBottomWidth: "5px",
              }}
            />
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                NumRowsSelected={selected.length}
                order={TransactionFilterObj.sortOrder}
                orderBy={TransactionFilterObj.sortColumn}
                sortId={this.state.sortId}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={data ? data.length : 0}
              />
              <TableBody>
                {!data ? (
                  <TableRow>
                    <TableCell
                      colSpan={20}
                      style={{ textAlign: "center", padding: "10px 0px" }}
                    >
                      {isDataEmpty && t("Report.inActive.NoDataFoundText")}
                    </TableCell>
                  </TableRow>
                ) : (
                  data &&
                  data.length > 0 &&
                  stableSort(
                    data,
                    getSorting(
                      TransactionFilterObj.sortOrder,
                      TransactionFilterObj.sortColumn
                    )
                  ).map((n) => {
                    const isSelected = this.isSelected(n && n.id);
                    const sx = {
                      color: "rgba(0, 0, 0, 0.87)",
                      fontSize: "0.8125rem",
                      fontWeight: 400,
                    };
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={n.id}
                        selected={isSelected}
                        sx={{ height: "50px" }}
                      >
                        <TableCell
                          padding="checkbox"
                          onClick={(event) => this.handleClick(event, n.id)}
                          sx={{ padding: "0 12px" }}
                        >
                          <Checkbox
                            checked={isSelected}
                            sx={{ "&.Mui-checked": { color: "#0ae" } }}
                          />
                        </TableCell>
                        <TableCell
                          padding={"none"}
                          component={"th"}
                          scope="row"
                        >
                          <Avatar alt="" src={n && n.picture_url} />
                        </TableCell>
                        <TableCell
                          padding={"none"}
                          onClick={(event) => this.handleClick(event, n.id)}
                          sx={{ ...sx }}
                        >
                          {n && n.name}
                        </TableCell>
                        <TableCell
                          padding={"none"}
                          onClick={(event) => this.handleClick(event, n.id)}
                          sx={{ ...sx }}
                        >
                          {n && n.username}
                        </TableCell>
                        <TableCell
                          padding={"none"}
                          onClick={(event) => this.handleClick(event, n.id)}
                          sx={{ ...sx }}
                        >
                          {n && n.accountname}
                        </TableCell>
                        <TableCell
                          padding={"none"}
                          onClick={(event) => this.handleClick(event, n.id)}
                          sx={{ ...sx }}
                        >
                          {n && n.phone}
                        </TableCell>
                        <TableCell
                          padding={"none"}
                          onClick={(event) => this.handleClick(event, n.id)}
                          sx={{ ...sx }}
                        >
                          {n &&
                            n.created_on &&
                            this.convertToTimeZone(n && n.created_on)}
                        </TableCell>
                        <TableCell
                          padding={"none"}
                          onClick={(event) => this.handleClick(event, n.id)}
                          sx={{ ...sx }}
                        >
                          {n &&
                            n.last_login_on &&
                            this.convertToTimeZone(n && n.last_login_on)}
                        </TableCell>
                        <TableCell
                          padding={"none"}
                          onClick={(event) => this.handleClick(event, n.id)}
                          sx={{ ...sx }}
                        >
                          {n.is_enabled === true || n.is_enabled === "true"
                            ? "Enabled"
                            : "Disabled"}
                        </TableCell>
                        <TableCell padding={"none"} sx={{ ...sx }}>
                          <IconButton
                            aria-label="More"
                            aria-owns={contextOpen ? "long-menu" : null}
                            aria-haspopup="true"
                            onClick={(event) =>
                              this.handleContextClick(event, n)
                            }
                          >
                            <MoreVertIcon style={{ fontSize: 20 }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </div>
          <ThemeProvider theme={localeTheme}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRecords || 0}
              rowsPerPage={TransactionFilterObj.pageSize}
              page={TransactionFilterObj.pageNo}
              backIconButtonProps={{
                "aria-label": "Previous Page",
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page",
              }}
              onPageChange={this.handleChangePage}
              onRowsPerPageChange={this.handleChangeRowsPerPage}
            />
          </ThemeProvider>
        </Paper>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(withTranslation()(UserInactiveReport));



// WEBPACK FOOTER //
// ./src/components/reports/users-inactive-report/index.js